import {
    ONBOARDING_FETCH_START,
    ONBOARDING_FETCH_SUCCESS,
    ONBOARDING_FETCH_FAILURE,
    ONBOARDING_MARK_STEP_LOCAL,
    ONBOARDING_MARK_FIRST_ACCESS_SEEN,
    ONBOARDING_OPEN_WELCOME_MODAL,
    ONBOARDING_CLOSE_WELCOME_MODAL,
    ONBOARDING_START_TOUR,
    ONBOARDING_END_TOUR,
    ONBOARDING_OPEN_CHECKLIST,
    ONBOARDING_CLOSE_CHECKLIST,
    ONBOARDING_RESET,
} from '../actions/onboarding';

const initialState = {
    loading: false,
    loaded: false,
    error: null,
    firstAccess: null,
    totalSteps: 0,
    completedSteps: 0,
    progressPercent: 0,
    allCompleted: false,
    steps: [],
    isWelcomeModalOpen: false,
    isChecklistOpen: false,
    activeTourId: null,
};

export default function onboarding(state = initialState, action) {
    switch (action.type) {
        case ONBOARDING_FETCH_START:
            return { ...state, loading: true, error: null };

        case ONBOARDING_FETCH_SUCCESS: {
            const p = action.payload || {};
            return {
                ...state,
                loading: false,
                loaded: true,
                error: null,
                firstAccess: p.firstAccess ?? p.firstaccess ?? null,
                totalSteps: p.totalSteps ?? 0,
                completedSteps: p.completedSteps ?? 0,
                progressPercent: p.progressPercent ?? 0,
                allCompleted: p.allCompleted ?? false,
                steps: Array.isArray(p.steps) ? p.steps : [],
            };
        }

        case ONBOARDING_FETCH_FAILURE:
            return { ...state, loading: false, error: action.error };

        case ONBOARDING_MARK_STEP_LOCAL: {
            const { stepId, completedAt, allStepsCompleted } = action;
            const updatedSteps = state.steps.map((s) => {
                if (s.stepId === stepId && !s.completed) {
                    return { ...s, completed: true, completedAt };
                }
                return s;
            });
            const completedCount = updatedSteps.filter((s) => s.completed).length;
            return {
                ...state,
                steps: updatedSteps,
                completedSteps: completedCount,
                progressPercent: state.totalSteps === 0
                    ? 0
                    : Math.round((completedCount * 100) / state.totalSteps),
                allCompleted: allStepsCompleted ?? completedCount === state.totalSteps,
            };
        }

        case ONBOARDING_MARK_FIRST_ACCESS_SEEN:
            return { ...state, firstAccess: true, isWelcomeModalOpen: false };

        case ONBOARDING_OPEN_WELCOME_MODAL:
            return { ...state, isWelcomeModalOpen: true };

        case ONBOARDING_CLOSE_WELCOME_MODAL:
            return { ...state, isWelcomeModalOpen: false };

        case ONBOARDING_START_TOUR:
            return { ...state, activeTourId: action.tourId };

        case ONBOARDING_END_TOUR:
            return { ...state, activeTourId: null };

        case ONBOARDING_OPEN_CHECKLIST:
            return { ...state, isChecklistOpen: true };

        case ONBOARDING_CLOSE_CHECKLIST:
            return { ...state, isChecklistOpen: false };

        case ONBOARDING_RESET:
            return initialState;

        default:
            return state;
    }
}
